const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAaaBadge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "currentColor"
    },
    d: "m10.151 40.892-1.6-8.255h-.064l-1.6 8.255zm-8.063 7.967 5.087-22.781h2.72l2.685 11.528-1.402 6.374-.419-.017H6.312l-.96 4.896z",
    transform: "scale(1.0407 .9609)",
    "aria-label": "A"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "currentColor",
      stroke: "currentColor"
    },
    d: "m36.445 32.9-3.2-16.51h-.127l-3.2 16.51ZM20.32 48.835 30.494 3.272h5.44l10.174 45.562H39.58l-1.92-9.79h-8.895l-1.92 9.79z",
    transform: "scale(1.0407 .9609)",
    "aria-label": "A"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "currentColor"
    },
    d: "m22.17 36.89-2.399-12.382h-.096l-2.4 12.383ZM10.077 48.842l7.631-34.171h4.08l6.37 26.951-3.454 6.18-1.62-6.303H16.41l-1.44 7.343z",
    transform: "scale(1.0407 .9609)",
    "aria-label": "A"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAaaBadge);
export default __webpack_public_path__ + "static/media/AAA_Badge.76142f177b4ade7176f0ce6a67ffdd78.svg";
export { ForwardRef as ReactComponent };